var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileRequestIconOne({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 7.66667C8.41286 7.66667 7.66667 8.41286 7.66667 9.33333C7.66667 10.2538 8.41286 11 9.33333 11C10.2538 11 11 10.2538 11 9.33333C11 8.41286 10.2538 7.66667 9.33333 7.66667ZM9.33333 7.66667V3.77778C9.33333 3.48309 9.21627 3.20048 9.0079 2.9921C8.79952 2.78373 8.51691 2.66667 8.22222 2.66667H6.55556M2.66667 4.33333C3.58714 4.33333 4.33333 3.58714 4.33333 2.66667C4.33333 1.74619 3.58714 1 2.66667 1C1.74619 1 1 1.74619 1 2.66667C1 3.58714 1.74619 4.33333 2.66667 4.33333ZM2.66667 4.33333V11",
    stroke: "#48BC69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRequestIconOne);
export default __webpack_public_path__ + "static/media/MobileRequestIconOne.6910d82a5991170ca2883a46b1f689e2.svg";
export { ForwardRef as ReactComponent };